import React from 'react';
import { observer, inject } from 'mobx-react';
import { Table } from 'react-bootstrap';
import Spinner from '../../../js/common/spinner';

@inject('stores') @observer
export default class ConfirmPage extends React.Component {
    constructor(props) {
        super(props);
        this.createCatchTheHeartInquiry = this.createCatchTheHeartInquiry.bind(this);
        this.doModify = this.doModify.bind(this);
    }

    createCatchTheHeartInquiry() {
        this.props.stores.createCatchTheHeartInquiry(this.props.history);
        return true;
    }

    doModify() {
        this.props.history.push('/');
    }

    render() {
        const stores = this.props.stores;
        return (
            <div className="contentMain">
                <div className="elem-status-step">
                    <ul className="step-2">
                        <li><span>0</span>1<span>.  内容入力</span></li>
                        <li><span>0</span>2<span>.  内容の確認</span></li>
                        <li><span>0</span>3<span>.  送信完了</span></li>
                    </ul>
                </div>
                <div className="contentMain">
                    <Spinner isLoading={this.props.stores.isLoading} />
                    <div className="form-inner">
                        <div className="fff">
                            <Table responsive className="confirm">
                                <tbody>
                                    <tr>
                                        <th colSpan="2">お名前（姓名）</th>
                                        <td colSpan="3">{stores.lastNameKanji} {stores.firstNameKanji}</td>
                                    </tr>
                                    <tr>
                                        <th colSpan="2">お名前（フリガナ）</th>
                                        <td colSpan="3">{stores.lastNameKana} {stores.firstNameKana}</td>
                                    </tr>
                                    <tr>
                                        <th colSpan="2">スタッフコード</th>
                                        <td colSpan="3">{stores.staffCode}</td>
                                    </tr>
                                    <tr>
                                        <th colSpan="2">電話番号</th>
                                        <td colSpan="3">{stores.phone}</td>
                                    </tr>
                                    <tr>
                                        <th colSpan="2">メールアドレス</th>
                                        <td colSpan="3">{stores.mail}</td>
                                    </tr>
                                    <tr>
                                        <th colSpan="2">内容</th>
                                        <td colSpan="3"><div className="message">
                                            {
                                                stores.detail.split("\n").map(
                                                    m => <p style={{margin: "0px"}}>{m}</p>,
                                                )
                                            }
                                        </div></td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>
                    <div className="elem-form-btn-wrapper">
                        <div className="elem-3btn">
                            <a href="#/"><button type="button" className="gray" onClick={this.doModify}>内容を修正する</button></a>
                            <button onClick={this.createCatchTheHeartInquiry} value="この内容で送信する" style={{ background: '#8a0808' }}>この内容で<br />送信する</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
